import { useContext, useState } from "react";
import { styles } from "../PedidosComponents";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { Select } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Proptypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import { UserContext } from "../../../context/UserContext";
import { PedidosContext } from "../../../context/PedidosContext";
import { MEDIO_DE_PAGO, PEDIDO_ESTADO } from "../../../constants";
import { useEffect } from "react";
import {
  esPagoEnCredito,
  esPagoEnEfectivo,
  incluyeRecargo,
  pagoConOtrosMedios,
} from "../../../extras/utils";

const useStyles = makeStyles(styles);

function Totales({ selectedUser, setSelectedUser, notadCredito }) {
  const classes = useStyles();

  const { users, getUsers } = useContext(UserContext);
  const {
    ventaActual,
    modificarVenta,
    subtotal,
    totalDevuelto,
    recargo,
    setRecargo,
    totalFinal,
  } = useContext(PedidosContext);
  const [userSearchInput, setUserSearchInput] = useState("");

  // Funcion que autocompleta los valores del medio de pago segun el campo seleccionado tomando como referencia el subtotal

  function autocompleteValues(
    field,
    value,
    paymentMethod,
    userOverride = null,
  ) {
    const monto = Number.parseFloat(value);
    if (isNaN(monto)) return;

    const user = userOverride || selectedUser;
    const saldoCredito = Number(user?.saldoCredito) || 0;

    let saldoNotaCredito =
      (user?.identificador === "9999" &&
        field === "pagoNotaCredito" &&
        monto) ||
      0;
    if (user?.identificador !== "9999")
      saldoNotaCredito = parseFloat(user?.saldoNotaCredito) || 0;
    const totalCobrable = subtotal - totalDevuelto - saldoNotaCredito;

    let credito = 0;
    let efectivo = 0;
    let otros = 0;
    let diff = 0;
    if (esPagoEnCredito(paymentMethod, saldoCredito)) {
      if (saldoCredito < totalCobrable) {
        credito = saldoCredito;
        diff = totalCobrable - saldoCredito;
      } else if (totalCobrable > 0) {
        credito = totalCobrable;
      }
    }

    if (field === "pagoNotaCredito") {
      if (esPagoEnEfectivo(paymentMethod)) {
        // Si modifica el pago en pagoCredito, se modifica el campo efectivo
        efectivo = totalCobrable;
      } else if (pagoConOtrosMedios(paymentMethod)) {
        // Si modifica el pago en pagoCredito, se modifica el campo otros
        otros = totalCobrable;
      }
    }

    if (field === "pagoCredito") {
      if (esPagoEnEfectivo(paymentMethod)) {
        // Si modifica el pago en pagoCredito, se modifica el campo efectivo
        efectivo = totalCobrable - credito;
      } else if (pagoConOtrosMedios(paymentMethod)) {
        // Si modifica el pago en pagoCredito, se modifica el campo otros
        otros = totalCobrable - credito;
      }
    }

    if (field === "pagoEfectivo") {
      if (monto > totalCobrable) {
        efectivo = totalCobrable - credito;
      } else {
        efectivo = Math.max(monto, diff);
      }
      if (pagoConOtrosMedios(paymentMethod)) {
        // Si modifica el pago en efectivo, se modifica el campo otros
        otros = totalCobrable - efectivo;
      }
    }

    if (field === "otros") {
      otros = Math.max(monto, diff);
      if (esPagoEnEfectivo(paymentMethod)) {
        // Si modifica el pago en otros, se modifica el campo efectivo
        efectivo = totalCobrable - otros;
      }
    }

    if (
      paymentMethod === MEDIO_DE_PAGO.TC ||
      paymentMethod === MEDIO_DE_PAGO.TD ||
      paymentMethod === MEDIO_DE_PAGO.TRANSFERENCIA
    ) {
      otros = totalCobrable;
      credito = 0;
      efectivo = 0;
    }

    // Bloque final donde se imputan los valores al objeto de ventas
    modificarVenta("pagoEfectivo", efectivo);
    modificarVenta("pagoCredito", credito);
    modificarVenta("otros", otros);
    modificarVenta("pagoNotaCredito", saldoNotaCredito);
  }

  // busca el usuario seleccionado y carga sus datos
  useEffect(() => {
    if (!selectedUser && ventaActual.compradorId) {
      const usuario = users.find(
        (usr) => usr.identificador === ventaActual.compradorId,
      );
      if (usuario) setSelectedUser(usuario);
    }
  }, [ventaActual.compradorId, users]);

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <div>
      <h5 className={classes.Totaltitle}>Subtotal</h5>
      <h2 name="subtotal" className={classes.TotalTexto}>
        ${subtotal}
      </h2>
      <h5 className={classes.Totaltitle}>Devoluciones</h5>
      <h2
        name="subtotal"
        className={`${classes.TotalTexto} ${classes.Descuento}`}
      >
        ${totalDevuelto}
      </h2>
      {notadCredito ? (
        <>
          <h5 className={classes.Totaltitle}>Notas de crédito</h5>
          <h2
            name="subtotal"
            className={`${classes.TotalTexto} ${classes.Descuento}`}
          >
            ${notadCredito}
          </h2>
        </>
      ) : null}

      <div className={classes.Line}></div>
      <h4 className={classes.Totaltitle}>Total</h4>
      <h1 name="total" className={classes.Totalresultado}>
        {notadCredito && notadCredito > totalFinal
          ? "0"
          : totalFinal < 0
            ? totalFinal.toFixed(2)
            : notadCredito
              ? (totalFinal - notadCredito).toFixed(2)
              : totalFinal.toFixed(2)}
      </h1>

      <Autocomplete
        className={classes.formControl}
        id="combo-box-demo"
        options={users}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        getOptionLabel={(option) => option.nombreCompleto}
        value={selectedUser}
        inputValue={userSearchInput}
        onInputChange={(_, newInputValue) => {
          setUserSearchInput(newInputValue);
        }}
        onChange={(_, value) => {
          if (!value) return;
          modificarVenta(
            "compradorId",
            value.identificador,
            value.saldoCredito,
          );
          if (ventaActual.medioDePago !== MEDIO_DE_PAGO.NINGUNO) {
            // Ya había un medio de pago elegido: recalculamos para el cliente nuevo
            // en vez de dejar todo en 0 esperando que alguien vuelva a tocar el select
            const field = esPagoEnCredito(
              ventaActual.medioDePago,
              value.saldoCredito,
            )
              ? "pagoCredito"
              : "pagoEfectivo";
            autocompleteValues(field, subtotal, ventaActual.medioDePago, value);
          } else {
            modificarVenta("pagoCredito", 0);
            modificarVenta("pagoEfectivo", 0);
            modificarVenta("otros", 0);
          }
          setSelectedUser(value);
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option._id}>
              {option.nombreCompleto}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} label="Elija un cliente" variant="outlined" />
        )}
      />

      {/*---------------------- MEDIO DE PAGO ---------------------- */}
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>Medio de pago</InputLabel>
        <Select
          variant="standard"
          native
          value={ventaActual.medioDePago}
          onChange={(e) => {
            // Si se modifica el metodo de pago setea el campo  que corresponda para que sea igual al total a cobrar
            const field = esPagoEnCredito(
              e.target.value,
              selectedUser?.saldoCredito,
            )
              ? "pagoCredito"
              : "pagoEfectivo";
            autocompleteValues(field, subtotal, e.target.value);
            modificarVenta(
              "medioDePago",
              e.target.value,
              selectedUser?.saldoCredito,
            );
          }}
          label="Medio De Pago"
          inputProps={{ name: "medioDePago", id: "medioDePago" }}
        >
          <option value={MEDIO_DE_PAGO.NINGUNO}>Ninguno</option>
          {ventaActual.compradorId !== "9999" && (
            <option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE}>
              Cuenta Corriente
            </option>
          )}
          <option value={MEDIO_DE_PAGO.EFECTIVO}>Efectivo</option>
          {ventaActual.compradorId !== "9999" && (
            <option value={MEDIO_DE_PAGO.CREDITO_Y_EFECTIVO}>
              Cuenta Corriente + Efectivo
            </option>
          )}
          <option value={MEDIO_DE_PAGO.TC}>Tarjeta Credito</option>
          <option value={MEDIO_DE_PAGO.TD}>Tarjeta Debito</option>
          <option value={MEDIO_DE_PAGO.EFECTIVO_Y_TC}>Efectivo + TC</option>
          <option value={MEDIO_DE_PAGO.EFECTIVO_Y_TD}>Efectivo + TD</option>
          {ventaActual.compradorId !== "9999" && (
            <option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TC}>
              Cuenta C. + TC
            </option>
          )}
          {ventaActual.compradorId !== "9999" && (
            <option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TD}>
              Cuenta C. + TD
            </option>
          )}
          <option value={MEDIO_DE_PAGO.EFECTIVO_Y_TRANSFERENCIA}>
            Efectivo + Transferencia
          </option>
          {ventaActual.compradorId !== "9999" && (
            <option value={MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TRANSFERENCIA}>
              Cuenta C. + Transferencia
            </option>
          )}
          <option value={MEDIO_DE_PAGO.TRANSFERENCIA}>Transferencia</option>
        </Select>
      </FormControl>
      {/*---------------------- ESTADO ---------------------- */}
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>Estado</InputLabel>
        <Select
          variant="standard"
          native
          value={ventaActual.estado}
          onChange={(e) => {
            modificarVenta("estado", e.target.value);
          }}
          label="estado"
          inputProps={{
            name: "estado",
            id: "estado",
          }}
        >
          <option aria-label="Ninguno" defaultValue value="" />
          <option value={PEDIDO_ESTADO.PENDIENTE}>Pendiente</option>
          <option value={PEDIDO_ESTADO.CONFIRMADO}>Confirmado</option>
          <option value={PEDIDO_ESTADO.PRODUCCION}>Produccion</option>
          <option value={PEDIDO_ESTADO.LISTO}>Listo a entregar</option>
          <option value={PEDIDO_ESTADO.ENTREGADO}>Entregado</option>
        </Select>
      </FormControl>
      {esPagoEnEfectivo(ventaActual.medioDePago) ? (
        <TextField
          className={classes.formControl}
          id="efectivo"
          name="efectivo"
          type="number"
          label="Monto en efectivo"
          variant="outlined"
          value={ventaActual.pagoEfectivo}
          onChange={(e) => {
            autocompleteValues(
              "pagoEfectivo",
              e.target.value,
              ventaActual.medioDePago,
            );
          }}
        />
      ) : null}
      {esPagoEnCredito(ventaActual.medioDePago, selectedUser?.saldoCredito) ? (
        <TextField
          className={classes.formControl}
          id="credito"
          name="credito"
          type="number"
          label="Pago en crédito"
          variant="outlined"
          value={ventaActual.pagoCredito}
          onChange={(e) => {
            autocompleteValues(
              "pagoCredito",
              e.target.value,
              ventaActual.medioDePago,
            );
          }}
        />
      ) : null}
      {pagoConOtrosMedios(ventaActual.medioDePago) ? (
        <TextField
          className={classes.formControl}
          id="otros"
          name="otros"
          type="number"
          label="Otros medios de pago"
          variant="outlined"
          helperText={`${recargo ? "Monto final en TC  $" + ventaActual.otros * (1 + recargo / 100) : ""}`}
          value={ventaActual.otros}
          onChange={(e) => {
            autocompleteValues(
              "otros",
              e.target.value,
              ventaActual.medioDePago,
            );
          }}
        />
      ) : null}
      {incluyeRecargo(ventaActual.medioDePago) ? (
        <TextField
          className={classes.formControl}
          id="recargo"
          name="recargo"
          type="number"
          label="% de recargo"
          variant="outlined"
          value={recargo}
          onChange={(e) => {
            try {
              let value = parseFloat(e.target.value);
              if (!isNaN(value)) setRecargo(value);
            } catch (error) {
              setRecargo(0);
            }
          }}
        />
      ) : null}
      {ventaActual.compradorId === "9999" && (
        <TextField
          className={classes.formControl}
          id="pagoNotaCredito"
          name="pagoNotaCredito"
          type="number"
          label="Pago con nota de credito"
          variant="outlined"
          value={ventaActual.pagoNotaCredito}
          onChange={(e) => {
            autocompleteValues(
              "pagoNotaCredito",
              e.target.value,
              ventaActual.medioDePago,
            );
          }}
        />
      )}
      <TextField
        className={classes.formControl}
        id="observaciones"
        name="observaciones"
        type="text"
        multiline
        label="Observaciones"
        variant="outlined"
        value={ventaActual.observaciones}
        onChange={(e) => {
          modificarVenta("observaciones", e.target.value);
        }}
      />
    </div>
  );
}

Totales.propTypes = {
  setSelectedUser: Proptypes.func,
  selectedUser: Proptypes.object,
  notadCredito: Proptypes.number,
};

export default Totales;
